import script from "./EditQuiz.vue?vue&type=script&setup=true&lang=js"
export * from "./EditQuiz.vue?vue&type=script&setup=true&lang=js"

import "./EditQuiz.vue?vue&type=style&index=0&id=862ea44c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-862ea44c"]])

export default __exports__